// source: acompanha/checkouts/v1/checkouts.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var acompanha_common_v1_common_pb = require('../../../acompanha/common/v1/common_pb.js');
goog.object.extend(proto, acompanha_common_v1_common_pb);
var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
goog.exportSymbol('proto.acompanha.checkouts.v1.Checkout', null, global);
goog.exportSymbol('proto.acompanha.checkouts.v1.CheckoutListItem', null, global);
goog.exportSymbol('proto.acompanha.checkouts.v1.CreateCheckoutRequest', null, global);
goog.exportSymbol('proto.acompanha.checkouts.v1.CreateCheckoutResponse', null, global);
goog.exportSymbol('proto.acompanha.checkouts.v1.DeleteCheckoutRequest', null, global);
goog.exportSymbol('proto.acompanha.checkouts.v1.GetCheckoutRequest', null, global);
goog.exportSymbol('proto.acompanha.checkouts.v1.GetCheckoutResponse', null, global);
goog.exportSymbol('proto.acompanha.checkouts.v1.ListCheckoutsRequest', null, global);
goog.exportSymbol('proto.acompanha.checkouts.v1.ListCheckoutsResponse', null, global);
goog.exportSymbol('proto.acompanha.checkouts.v1.QuickCheckoutRequest', null, global);
goog.exportSymbol('proto.acompanha.checkouts.v1.QuickCheckoutResponse', null, global);
goog.exportSymbol('proto.acompanha.checkouts.v1.UpdateCheckoutRequest', null, global);
goog.exportSymbol('proto.acompanha.checkouts.v1.UpdateCheckoutResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.checkouts.v1.Checkout = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.acompanha.checkouts.v1.Checkout.repeatedFields_, null);
};
goog.inherits(proto.acompanha.checkouts.v1.Checkout, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.checkouts.v1.Checkout.displayName = 'proto.acompanha.checkouts.v1.Checkout';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.checkouts.v1.CheckoutListItem = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.acompanha.checkouts.v1.CheckoutListItem.repeatedFields_, null);
};
goog.inherits(proto.acompanha.checkouts.v1.CheckoutListItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.checkouts.v1.CheckoutListItem.displayName = 'proto.acompanha.checkouts.v1.CheckoutListItem';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.checkouts.v1.ListCheckoutsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.checkouts.v1.ListCheckoutsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.checkouts.v1.ListCheckoutsRequest.displayName = 'proto.acompanha.checkouts.v1.ListCheckoutsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.checkouts.v1.ListCheckoutsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.acompanha.checkouts.v1.ListCheckoutsResponse.repeatedFields_, null);
};
goog.inherits(proto.acompanha.checkouts.v1.ListCheckoutsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.checkouts.v1.ListCheckoutsResponse.displayName = 'proto.acompanha.checkouts.v1.ListCheckoutsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.checkouts.v1.GetCheckoutRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.checkouts.v1.GetCheckoutRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.checkouts.v1.GetCheckoutRequest.displayName = 'proto.acompanha.checkouts.v1.GetCheckoutRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.checkouts.v1.GetCheckoutResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.checkouts.v1.GetCheckoutResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.checkouts.v1.GetCheckoutResponse.displayName = 'proto.acompanha.checkouts.v1.GetCheckoutResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.checkouts.v1.CreateCheckoutRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.acompanha.checkouts.v1.CreateCheckoutRequest.repeatedFields_, null);
};
goog.inherits(proto.acompanha.checkouts.v1.CreateCheckoutRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.checkouts.v1.CreateCheckoutRequest.displayName = 'proto.acompanha.checkouts.v1.CreateCheckoutRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.checkouts.v1.CreateCheckoutResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.checkouts.v1.CreateCheckoutResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.checkouts.v1.CreateCheckoutResponse.displayName = 'proto.acompanha.checkouts.v1.CreateCheckoutResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.checkouts.v1.UpdateCheckoutRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.acompanha.checkouts.v1.UpdateCheckoutRequest.repeatedFields_, null);
};
goog.inherits(proto.acompanha.checkouts.v1.UpdateCheckoutRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.checkouts.v1.UpdateCheckoutRequest.displayName = 'proto.acompanha.checkouts.v1.UpdateCheckoutRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.checkouts.v1.UpdateCheckoutResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.checkouts.v1.UpdateCheckoutResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.checkouts.v1.UpdateCheckoutResponse.displayName = 'proto.acompanha.checkouts.v1.UpdateCheckoutResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.checkouts.v1.DeleteCheckoutRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.checkouts.v1.DeleteCheckoutRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.checkouts.v1.DeleteCheckoutRequest.displayName = 'proto.acompanha.checkouts.v1.DeleteCheckoutRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.checkouts.v1.QuickCheckoutRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.checkouts.v1.QuickCheckoutRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.checkouts.v1.QuickCheckoutRequest.displayName = 'proto.acompanha.checkouts.v1.QuickCheckoutRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.checkouts.v1.QuickCheckoutResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.checkouts.v1.QuickCheckoutResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.checkouts.v1.QuickCheckoutResponse.displayName = 'proto.acompanha.checkouts.v1.QuickCheckoutResponse';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.acompanha.checkouts.v1.Checkout.repeatedFields_ = [4,8];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.checkouts.v1.Checkout.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.checkouts.v1.Checkout.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.checkouts.v1.Checkout} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.checkouts.v1.Checkout.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
customer: (f = msg.getCustomer()) && acompanha_common_v1_common_pb.CustomerRef.toObject(includeInstance, f),
shippingMethod: (f = msg.getShippingMethod()) && acompanha_common_v1_common_pb.ShippingMethodRef.toObject(includeInstance, f),
productsList: jspb.Message.toObjectList(msg.getProductsList(),
    acompanha_common_v1_common_pb.CheckoutProduct.toObject, includeInstance),
amount: jspb.Message.getFieldWithDefault(msg, 5, 0),
salesChannel: (f = msg.getSalesChannel()) && acompanha_common_v1_common_pb.SalesChannelRef.toObject(includeInstance, f),
finishOrder: jspb.Message.getBooleanFieldWithDefault(msg, 7, false),
paymentMethodsList: jspb.Message.toObjectList(msg.getPaymentMethodsList(),
    acompanha_common_v1_common_pb.PaymentMethod.toObject, includeInstance),
paymentDetails: (f = msg.getPaymentDetails()) && acompanha_common_v1_common_pb.PaymentDetails.toObject(includeInstance, f),
photo: jspb.Message.getFieldWithDefault(msg, 10, ""),
photoUrl: jspb.Message.getFieldWithDefault(msg, 11, ""),
isQuickCheckout: jspb.Message.getBooleanFieldWithDefault(msg, 12, false),
useQuickCheckoutCreationDate: jspb.Message.getBooleanFieldWithDefault(msg, 13, false),
createdAt: (f = msg.getCreatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
updatedAt: (f = msg.getUpdatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.checkouts.v1.Checkout}
 */
proto.acompanha.checkouts.v1.Checkout.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.checkouts.v1.Checkout;
  return proto.acompanha.checkouts.v1.Checkout.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.checkouts.v1.Checkout} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.checkouts.v1.Checkout}
 */
proto.acompanha.checkouts.v1.Checkout.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = new acompanha_common_v1_common_pb.CustomerRef;
      reader.readMessage(value,acompanha_common_v1_common_pb.CustomerRef.deserializeBinaryFromReader);
      msg.setCustomer(value);
      break;
    case 3:
      var value = new acompanha_common_v1_common_pb.ShippingMethodRef;
      reader.readMessage(value,acompanha_common_v1_common_pb.ShippingMethodRef.deserializeBinaryFromReader);
      msg.setShippingMethod(value);
      break;
    case 4:
      var value = new acompanha_common_v1_common_pb.CheckoutProduct;
      reader.readMessage(value,acompanha_common_v1_common_pb.CheckoutProduct.deserializeBinaryFromReader);
      msg.addProducts(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAmount(value);
      break;
    case 6:
      var value = new acompanha_common_v1_common_pb.SalesChannelRef;
      reader.readMessage(value,acompanha_common_v1_common_pb.SalesChannelRef.deserializeBinaryFromReader);
      msg.setSalesChannel(value);
      break;
    case 7:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setFinishOrder(value);
      break;
    case 8:
      var value = new acompanha_common_v1_common_pb.PaymentMethod;
      reader.readMessage(value,acompanha_common_v1_common_pb.PaymentMethod.deserializeBinaryFromReader);
      msg.addPaymentMethods(value);
      break;
    case 9:
      var value = new acompanha_common_v1_common_pb.PaymentDetails;
      reader.readMessage(value,acompanha_common_v1_common_pb.PaymentDetails.deserializeBinaryFromReader);
      msg.setPaymentDetails(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setPhoto(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setPhotoUrl(value);
      break;
    case 12:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsQuickCheckout(value);
      break;
    case 13:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setUseQuickCheckoutCreationDate(value);
      break;
    case 14:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedAt(value);
      break;
    case 15:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUpdatedAt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.checkouts.v1.Checkout.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.checkouts.v1.Checkout.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.checkouts.v1.Checkout} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.checkouts.v1.Checkout.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCustomer();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      acompanha_common_v1_common_pb.CustomerRef.serializeBinaryToWriter
    );
  }
  f = message.getShippingMethod();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      acompanha_common_v1_common_pb.ShippingMethodRef.serializeBinaryToWriter
    );
  }
  f = message.getProductsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      acompanha_common_v1_common_pb.CheckoutProduct.serializeBinaryToWriter
    );
  }
  f = message.getAmount();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getSalesChannel();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      acompanha_common_v1_common_pb.SalesChannelRef.serializeBinaryToWriter
    );
  }
  f = message.getFinishOrder();
  if (f) {
    writer.writeBool(
      7,
      f
    );
  }
  f = message.getPaymentMethodsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      8,
      f,
      acompanha_common_v1_common_pb.PaymentMethod.serializeBinaryToWriter
    );
  }
  f = message.getPaymentDetails();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      acompanha_common_v1_common_pb.PaymentDetails.serializeBinaryToWriter
    );
  }
  f = message.getPhoto();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getPhotoUrl();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getIsQuickCheckout();
  if (f) {
    writer.writeBool(
      12,
      f
    );
  }
  f = message.getUseQuickCheckoutCreationDate();
  if (f) {
    writer.writeBool(
      13,
      f
    );
  }
  f = message.getCreatedAt();
  if (f != null) {
    writer.writeMessage(
      14,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getUpdatedAt();
  if (f != null) {
    writer.writeMessage(
      15,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.acompanha.checkouts.v1.Checkout.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.checkouts.v1.Checkout} returns this
 */
proto.acompanha.checkouts.v1.Checkout.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional acompanha.common.v1.CustomerRef customer = 2;
 * @return {?proto.acompanha.common.v1.CustomerRef}
 */
proto.acompanha.checkouts.v1.Checkout.prototype.getCustomer = function() {
  return /** @type{?proto.acompanha.common.v1.CustomerRef} */ (
    jspb.Message.getWrapperField(this, acompanha_common_v1_common_pb.CustomerRef, 2));
};


/**
 * @param {?proto.acompanha.common.v1.CustomerRef|undefined} value
 * @return {!proto.acompanha.checkouts.v1.Checkout} returns this
*/
proto.acompanha.checkouts.v1.Checkout.prototype.setCustomer = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.checkouts.v1.Checkout} returns this
 */
proto.acompanha.checkouts.v1.Checkout.prototype.clearCustomer = function() {
  return this.setCustomer(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.checkouts.v1.Checkout.prototype.hasCustomer = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional acompanha.common.v1.ShippingMethodRef shipping_method = 3;
 * @return {?proto.acompanha.common.v1.ShippingMethodRef}
 */
proto.acompanha.checkouts.v1.Checkout.prototype.getShippingMethod = function() {
  return /** @type{?proto.acompanha.common.v1.ShippingMethodRef} */ (
    jspb.Message.getWrapperField(this, acompanha_common_v1_common_pb.ShippingMethodRef, 3));
};


/**
 * @param {?proto.acompanha.common.v1.ShippingMethodRef|undefined} value
 * @return {!proto.acompanha.checkouts.v1.Checkout} returns this
*/
proto.acompanha.checkouts.v1.Checkout.prototype.setShippingMethod = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.checkouts.v1.Checkout} returns this
 */
proto.acompanha.checkouts.v1.Checkout.prototype.clearShippingMethod = function() {
  return this.setShippingMethod(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.checkouts.v1.Checkout.prototype.hasShippingMethod = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * repeated acompanha.common.v1.CheckoutProduct products = 4;
 * @return {!Array<!proto.acompanha.common.v1.CheckoutProduct>}
 */
proto.acompanha.checkouts.v1.Checkout.prototype.getProductsList = function() {
  return /** @type{!Array<!proto.acompanha.common.v1.CheckoutProduct>} */ (
    jspb.Message.getRepeatedWrapperField(this, acompanha_common_v1_common_pb.CheckoutProduct, 4));
};


/**
 * @param {!Array<!proto.acompanha.common.v1.CheckoutProduct>} value
 * @return {!proto.acompanha.checkouts.v1.Checkout} returns this
*/
proto.acompanha.checkouts.v1.Checkout.prototype.setProductsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.acompanha.common.v1.CheckoutProduct=} opt_value
 * @param {number=} opt_index
 * @return {!proto.acompanha.common.v1.CheckoutProduct}
 */
proto.acompanha.checkouts.v1.Checkout.prototype.addProducts = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.acompanha.common.v1.CheckoutProduct, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.acompanha.checkouts.v1.Checkout} returns this
 */
proto.acompanha.checkouts.v1.Checkout.prototype.clearProductsList = function() {
  return this.setProductsList([]);
};


/**
 * optional int64 amount = 5;
 * @return {number}
 */
proto.acompanha.checkouts.v1.Checkout.prototype.getAmount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.checkouts.v1.Checkout} returns this
 */
proto.acompanha.checkouts.v1.Checkout.prototype.setAmount = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional acompanha.common.v1.SalesChannelRef sales_channel = 6;
 * @return {?proto.acompanha.common.v1.SalesChannelRef}
 */
proto.acompanha.checkouts.v1.Checkout.prototype.getSalesChannel = function() {
  return /** @type{?proto.acompanha.common.v1.SalesChannelRef} */ (
    jspb.Message.getWrapperField(this, acompanha_common_v1_common_pb.SalesChannelRef, 6));
};


/**
 * @param {?proto.acompanha.common.v1.SalesChannelRef|undefined} value
 * @return {!proto.acompanha.checkouts.v1.Checkout} returns this
*/
proto.acompanha.checkouts.v1.Checkout.prototype.setSalesChannel = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.checkouts.v1.Checkout} returns this
 */
proto.acompanha.checkouts.v1.Checkout.prototype.clearSalesChannel = function() {
  return this.setSalesChannel(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.checkouts.v1.Checkout.prototype.hasSalesChannel = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional bool finish_order = 7;
 * @return {boolean}
 */
proto.acompanha.checkouts.v1.Checkout.prototype.getFinishOrder = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 7, false));
};


/**
 * @param {boolean} value
 * @return {!proto.acompanha.checkouts.v1.Checkout} returns this
 */
proto.acompanha.checkouts.v1.Checkout.prototype.setFinishOrder = function(value) {
  return jspb.Message.setProto3BooleanField(this, 7, value);
};


/**
 * repeated acompanha.common.v1.PaymentMethod payment_methods = 8;
 * @return {!Array<!proto.acompanha.common.v1.PaymentMethod>}
 */
proto.acompanha.checkouts.v1.Checkout.prototype.getPaymentMethodsList = function() {
  return /** @type{!Array<!proto.acompanha.common.v1.PaymentMethod>} */ (
    jspb.Message.getRepeatedWrapperField(this, acompanha_common_v1_common_pb.PaymentMethod, 8));
};


/**
 * @param {!Array<!proto.acompanha.common.v1.PaymentMethod>} value
 * @return {!proto.acompanha.checkouts.v1.Checkout} returns this
*/
proto.acompanha.checkouts.v1.Checkout.prototype.setPaymentMethodsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 8, value);
};


/**
 * @param {!proto.acompanha.common.v1.PaymentMethod=} opt_value
 * @param {number=} opt_index
 * @return {!proto.acompanha.common.v1.PaymentMethod}
 */
proto.acompanha.checkouts.v1.Checkout.prototype.addPaymentMethods = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 8, opt_value, proto.acompanha.common.v1.PaymentMethod, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.acompanha.checkouts.v1.Checkout} returns this
 */
proto.acompanha.checkouts.v1.Checkout.prototype.clearPaymentMethodsList = function() {
  return this.setPaymentMethodsList([]);
};


/**
 * optional acompanha.common.v1.PaymentDetails payment_details = 9;
 * @return {?proto.acompanha.common.v1.PaymentDetails}
 */
proto.acompanha.checkouts.v1.Checkout.prototype.getPaymentDetails = function() {
  return /** @type{?proto.acompanha.common.v1.PaymentDetails} */ (
    jspb.Message.getWrapperField(this, acompanha_common_v1_common_pb.PaymentDetails, 9));
};


/**
 * @param {?proto.acompanha.common.v1.PaymentDetails|undefined} value
 * @return {!proto.acompanha.checkouts.v1.Checkout} returns this
*/
proto.acompanha.checkouts.v1.Checkout.prototype.setPaymentDetails = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.checkouts.v1.Checkout} returns this
 */
proto.acompanha.checkouts.v1.Checkout.prototype.clearPaymentDetails = function() {
  return this.setPaymentDetails(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.checkouts.v1.Checkout.prototype.hasPaymentDetails = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional string photo = 10;
 * @return {string}
 */
proto.acompanha.checkouts.v1.Checkout.prototype.getPhoto = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.checkouts.v1.Checkout} returns this
 */
proto.acompanha.checkouts.v1.Checkout.prototype.setPhoto = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string photo_url = 11;
 * @return {string}
 */
proto.acompanha.checkouts.v1.Checkout.prototype.getPhotoUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.checkouts.v1.Checkout} returns this
 */
proto.acompanha.checkouts.v1.Checkout.prototype.setPhotoUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional bool is_quick_checkout = 12;
 * @return {boolean}
 */
proto.acompanha.checkouts.v1.Checkout.prototype.getIsQuickCheckout = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 12, false));
};


/**
 * @param {boolean} value
 * @return {!proto.acompanha.checkouts.v1.Checkout} returns this
 */
proto.acompanha.checkouts.v1.Checkout.prototype.setIsQuickCheckout = function(value) {
  return jspb.Message.setProto3BooleanField(this, 12, value);
};


/**
 * optional bool use_quick_checkout_creation_date = 13;
 * @return {boolean}
 */
proto.acompanha.checkouts.v1.Checkout.prototype.getUseQuickCheckoutCreationDate = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 13, false));
};


/**
 * @param {boolean} value
 * @return {!proto.acompanha.checkouts.v1.Checkout} returns this
 */
proto.acompanha.checkouts.v1.Checkout.prototype.setUseQuickCheckoutCreationDate = function(value) {
  return jspb.Message.setProto3BooleanField(this, 13, value);
};


/**
 * optional google.protobuf.Timestamp created_at = 14;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.acompanha.checkouts.v1.Checkout.prototype.getCreatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 14));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.acompanha.checkouts.v1.Checkout} returns this
*/
proto.acompanha.checkouts.v1.Checkout.prototype.setCreatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 14, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.checkouts.v1.Checkout} returns this
 */
proto.acompanha.checkouts.v1.Checkout.prototype.clearCreatedAt = function() {
  return this.setCreatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.checkouts.v1.Checkout.prototype.hasCreatedAt = function() {
  return jspb.Message.getField(this, 14) != null;
};


/**
 * optional google.protobuf.Timestamp updated_at = 15;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.acompanha.checkouts.v1.Checkout.prototype.getUpdatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 15));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.acompanha.checkouts.v1.Checkout} returns this
*/
proto.acompanha.checkouts.v1.Checkout.prototype.setUpdatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 15, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.checkouts.v1.Checkout} returns this
 */
proto.acompanha.checkouts.v1.Checkout.prototype.clearUpdatedAt = function() {
  return this.setUpdatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.checkouts.v1.Checkout.prototype.hasUpdatedAt = function() {
  return jspb.Message.getField(this, 15) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.acompanha.checkouts.v1.CheckoutListItem.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.checkouts.v1.CheckoutListItem.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.checkouts.v1.CheckoutListItem.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.checkouts.v1.CheckoutListItem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.checkouts.v1.CheckoutListItem.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
customer: (f = msg.getCustomer()) && acompanha_common_v1_common_pb.CustomerRef.toObject(includeInstance, f),
productsList: jspb.Message.toObjectList(msg.getProductsList(),
    acompanha_common_v1_common_pb.CheckoutProduct.toObject, includeInstance),
salesChannel: (f = msg.getSalesChannel()) && acompanha_common_v1_common_pb.SalesChannelRef.toObject(includeInstance, f),
amount: jspb.Message.getFieldWithDefault(msg, 5, 0),
photo: jspb.Message.getFieldWithDefault(msg, 6, ""),
photoUrl: jspb.Message.getFieldWithDefault(msg, 7, ""),
createdAt: (f = msg.getCreatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.checkouts.v1.CheckoutListItem}
 */
proto.acompanha.checkouts.v1.CheckoutListItem.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.checkouts.v1.CheckoutListItem;
  return proto.acompanha.checkouts.v1.CheckoutListItem.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.checkouts.v1.CheckoutListItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.checkouts.v1.CheckoutListItem}
 */
proto.acompanha.checkouts.v1.CheckoutListItem.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = new acompanha_common_v1_common_pb.CustomerRef;
      reader.readMessage(value,acompanha_common_v1_common_pb.CustomerRef.deserializeBinaryFromReader);
      msg.setCustomer(value);
      break;
    case 3:
      var value = new acompanha_common_v1_common_pb.CheckoutProduct;
      reader.readMessage(value,acompanha_common_v1_common_pb.CheckoutProduct.deserializeBinaryFromReader);
      msg.addProducts(value);
      break;
    case 4:
      var value = new acompanha_common_v1_common_pb.SalesChannelRef;
      reader.readMessage(value,acompanha_common_v1_common_pb.SalesChannelRef.deserializeBinaryFromReader);
      msg.setSalesChannel(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAmount(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setPhoto(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setPhotoUrl(value);
      break;
    case 8:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedAt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.checkouts.v1.CheckoutListItem.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.checkouts.v1.CheckoutListItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.checkouts.v1.CheckoutListItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.checkouts.v1.CheckoutListItem.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCustomer();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      acompanha_common_v1_common_pb.CustomerRef.serializeBinaryToWriter
    );
  }
  f = message.getProductsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      acompanha_common_v1_common_pb.CheckoutProduct.serializeBinaryToWriter
    );
  }
  f = message.getSalesChannel();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      acompanha_common_v1_common_pb.SalesChannelRef.serializeBinaryToWriter
    );
  }
  f = message.getAmount();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getPhoto();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getPhotoUrl();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getCreatedAt();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.acompanha.checkouts.v1.CheckoutListItem.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.checkouts.v1.CheckoutListItem} returns this
 */
proto.acompanha.checkouts.v1.CheckoutListItem.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional acompanha.common.v1.CustomerRef customer = 2;
 * @return {?proto.acompanha.common.v1.CustomerRef}
 */
proto.acompanha.checkouts.v1.CheckoutListItem.prototype.getCustomer = function() {
  return /** @type{?proto.acompanha.common.v1.CustomerRef} */ (
    jspb.Message.getWrapperField(this, acompanha_common_v1_common_pb.CustomerRef, 2));
};


/**
 * @param {?proto.acompanha.common.v1.CustomerRef|undefined} value
 * @return {!proto.acompanha.checkouts.v1.CheckoutListItem} returns this
*/
proto.acompanha.checkouts.v1.CheckoutListItem.prototype.setCustomer = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.checkouts.v1.CheckoutListItem} returns this
 */
proto.acompanha.checkouts.v1.CheckoutListItem.prototype.clearCustomer = function() {
  return this.setCustomer(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.checkouts.v1.CheckoutListItem.prototype.hasCustomer = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated acompanha.common.v1.CheckoutProduct products = 3;
 * @return {!Array<!proto.acompanha.common.v1.CheckoutProduct>}
 */
proto.acompanha.checkouts.v1.CheckoutListItem.prototype.getProductsList = function() {
  return /** @type{!Array<!proto.acompanha.common.v1.CheckoutProduct>} */ (
    jspb.Message.getRepeatedWrapperField(this, acompanha_common_v1_common_pb.CheckoutProduct, 3));
};


/**
 * @param {!Array<!proto.acompanha.common.v1.CheckoutProduct>} value
 * @return {!proto.acompanha.checkouts.v1.CheckoutListItem} returns this
*/
proto.acompanha.checkouts.v1.CheckoutListItem.prototype.setProductsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.acompanha.common.v1.CheckoutProduct=} opt_value
 * @param {number=} opt_index
 * @return {!proto.acompanha.common.v1.CheckoutProduct}
 */
proto.acompanha.checkouts.v1.CheckoutListItem.prototype.addProducts = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.acompanha.common.v1.CheckoutProduct, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.acompanha.checkouts.v1.CheckoutListItem} returns this
 */
proto.acompanha.checkouts.v1.CheckoutListItem.prototype.clearProductsList = function() {
  return this.setProductsList([]);
};


/**
 * optional acompanha.common.v1.SalesChannelRef sales_channel = 4;
 * @return {?proto.acompanha.common.v1.SalesChannelRef}
 */
proto.acompanha.checkouts.v1.CheckoutListItem.prototype.getSalesChannel = function() {
  return /** @type{?proto.acompanha.common.v1.SalesChannelRef} */ (
    jspb.Message.getWrapperField(this, acompanha_common_v1_common_pb.SalesChannelRef, 4));
};


/**
 * @param {?proto.acompanha.common.v1.SalesChannelRef|undefined} value
 * @return {!proto.acompanha.checkouts.v1.CheckoutListItem} returns this
*/
proto.acompanha.checkouts.v1.CheckoutListItem.prototype.setSalesChannel = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.checkouts.v1.CheckoutListItem} returns this
 */
proto.acompanha.checkouts.v1.CheckoutListItem.prototype.clearSalesChannel = function() {
  return this.setSalesChannel(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.checkouts.v1.CheckoutListItem.prototype.hasSalesChannel = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional int64 amount = 5;
 * @return {number}
 */
proto.acompanha.checkouts.v1.CheckoutListItem.prototype.getAmount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.checkouts.v1.CheckoutListItem} returns this
 */
proto.acompanha.checkouts.v1.CheckoutListItem.prototype.setAmount = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional string photo = 6;
 * @return {string}
 */
proto.acompanha.checkouts.v1.CheckoutListItem.prototype.getPhoto = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.checkouts.v1.CheckoutListItem} returns this
 */
proto.acompanha.checkouts.v1.CheckoutListItem.prototype.setPhoto = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string photo_url = 7;
 * @return {string}
 */
proto.acompanha.checkouts.v1.CheckoutListItem.prototype.getPhotoUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.checkouts.v1.CheckoutListItem} returns this
 */
proto.acompanha.checkouts.v1.CheckoutListItem.prototype.setPhotoUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional google.protobuf.Timestamp created_at = 8;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.acompanha.checkouts.v1.CheckoutListItem.prototype.getCreatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 8));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.acompanha.checkouts.v1.CheckoutListItem} returns this
*/
proto.acompanha.checkouts.v1.CheckoutListItem.prototype.setCreatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.checkouts.v1.CheckoutListItem} returns this
 */
proto.acompanha.checkouts.v1.CheckoutListItem.prototype.clearCreatedAt = function() {
  return this.setCreatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.checkouts.v1.CheckoutListItem.prototype.hasCreatedAt = function() {
  return jspb.Message.getField(this, 8) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.checkouts.v1.ListCheckoutsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.checkouts.v1.ListCheckoutsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.checkouts.v1.ListCheckoutsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.checkouts.v1.ListCheckoutsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
pagination: (f = msg.getPagination()) && acompanha_common_v1_common_pb.PaginationRequest.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.checkouts.v1.ListCheckoutsRequest}
 */
proto.acompanha.checkouts.v1.ListCheckoutsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.checkouts.v1.ListCheckoutsRequest;
  return proto.acompanha.checkouts.v1.ListCheckoutsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.checkouts.v1.ListCheckoutsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.checkouts.v1.ListCheckoutsRequest}
 */
proto.acompanha.checkouts.v1.ListCheckoutsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new acompanha_common_v1_common_pb.PaginationRequest;
      reader.readMessage(value,acompanha_common_v1_common_pb.PaginationRequest.deserializeBinaryFromReader);
      msg.setPagination(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.checkouts.v1.ListCheckoutsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.checkouts.v1.ListCheckoutsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.checkouts.v1.ListCheckoutsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.checkouts.v1.ListCheckoutsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPagination();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      acompanha_common_v1_common_pb.PaginationRequest.serializeBinaryToWriter
    );
  }
};


/**
 * optional acompanha.common.v1.PaginationRequest pagination = 1;
 * @return {?proto.acompanha.common.v1.PaginationRequest}
 */
proto.acompanha.checkouts.v1.ListCheckoutsRequest.prototype.getPagination = function() {
  return /** @type{?proto.acompanha.common.v1.PaginationRequest} */ (
    jspb.Message.getWrapperField(this, acompanha_common_v1_common_pb.PaginationRequest, 1));
};


/**
 * @param {?proto.acompanha.common.v1.PaginationRequest|undefined} value
 * @return {!proto.acompanha.checkouts.v1.ListCheckoutsRequest} returns this
*/
proto.acompanha.checkouts.v1.ListCheckoutsRequest.prototype.setPagination = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.checkouts.v1.ListCheckoutsRequest} returns this
 */
proto.acompanha.checkouts.v1.ListCheckoutsRequest.prototype.clearPagination = function() {
  return this.setPagination(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.checkouts.v1.ListCheckoutsRequest.prototype.hasPagination = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.acompanha.checkouts.v1.ListCheckoutsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.checkouts.v1.ListCheckoutsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.checkouts.v1.ListCheckoutsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.checkouts.v1.ListCheckoutsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.checkouts.v1.ListCheckoutsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
checkoutsList: jspb.Message.toObjectList(msg.getCheckoutsList(),
    proto.acompanha.checkouts.v1.CheckoutListItem.toObject, includeInstance),
meta: (f = msg.getMeta()) && acompanha_common_v1_common_pb.PaginationMeta.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.checkouts.v1.ListCheckoutsResponse}
 */
proto.acompanha.checkouts.v1.ListCheckoutsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.checkouts.v1.ListCheckoutsResponse;
  return proto.acompanha.checkouts.v1.ListCheckoutsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.checkouts.v1.ListCheckoutsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.checkouts.v1.ListCheckoutsResponse}
 */
proto.acompanha.checkouts.v1.ListCheckoutsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.acompanha.checkouts.v1.CheckoutListItem;
      reader.readMessage(value,proto.acompanha.checkouts.v1.CheckoutListItem.deserializeBinaryFromReader);
      msg.addCheckouts(value);
      break;
    case 2:
      var value = new acompanha_common_v1_common_pb.PaginationMeta;
      reader.readMessage(value,acompanha_common_v1_common_pb.PaginationMeta.deserializeBinaryFromReader);
      msg.setMeta(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.checkouts.v1.ListCheckoutsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.checkouts.v1.ListCheckoutsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.checkouts.v1.ListCheckoutsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.checkouts.v1.ListCheckoutsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCheckoutsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.acompanha.checkouts.v1.CheckoutListItem.serializeBinaryToWriter
    );
  }
  f = message.getMeta();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      acompanha_common_v1_common_pb.PaginationMeta.serializeBinaryToWriter
    );
  }
};


/**
 * repeated CheckoutListItem checkouts = 1;
 * @return {!Array<!proto.acompanha.checkouts.v1.CheckoutListItem>}
 */
proto.acompanha.checkouts.v1.ListCheckoutsResponse.prototype.getCheckoutsList = function() {
  return /** @type{!Array<!proto.acompanha.checkouts.v1.CheckoutListItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.acompanha.checkouts.v1.CheckoutListItem, 1));
};


/**
 * @param {!Array<!proto.acompanha.checkouts.v1.CheckoutListItem>} value
 * @return {!proto.acompanha.checkouts.v1.ListCheckoutsResponse} returns this
*/
proto.acompanha.checkouts.v1.ListCheckoutsResponse.prototype.setCheckoutsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.acompanha.checkouts.v1.CheckoutListItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.acompanha.checkouts.v1.CheckoutListItem}
 */
proto.acompanha.checkouts.v1.ListCheckoutsResponse.prototype.addCheckouts = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.acompanha.checkouts.v1.CheckoutListItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.acompanha.checkouts.v1.ListCheckoutsResponse} returns this
 */
proto.acompanha.checkouts.v1.ListCheckoutsResponse.prototype.clearCheckoutsList = function() {
  return this.setCheckoutsList([]);
};


/**
 * optional acompanha.common.v1.PaginationMeta meta = 2;
 * @return {?proto.acompanha.common.v1.PaginationMeta}
 */
proto.acompanha.checkouts.v1.ListCheckoutsResponse.prototype.getMeta = function() {
  return /** @type{?proto.acompanha.common.v1.PaginationMeta} */ (
    jspb.Message.getWrapperField(this, acompanha_common_v1_common_pb.PaginationMeta, 2));
};


/**
 * @param {?proto.acompanha.common.v1.PaginationMeta|undefined} value
 * @return {!proto.acompanha.checkouts.v1.ListCheckoutsResponse} returns this
*/
proto.acompanha.checkouts.v1.ListCheckoutsResponse.prototype.setMeta = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.checkouts.v1.ListCheckoutsResponse} returns this
 */
proto.acompanha.checkouts.v1.ListCheckoutsResponse.prototype.clearMeta = function() {
  return this.setMeta(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.checkouts.v1.ListCheckoutsResponse.prototype.hasMeta = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.checkouts.v1.GetCheckoutRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.checkouts.v1.GetCheckoutRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.checkouts.v1.GetCheckoutRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.checkouts.v1.GetCheckoutRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
uuid: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.checkouts.v1.GetCheckoutRequest}
 */
proto.acompanha.checkouts.v1.GetCheckoutRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.checkouts.v1.GetCheckoutRequest;
  return proto.acompanha.checkouts.v1.GetCheckoutRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.checkouts.v1.GetCheckoutRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.checkouts.v1.GetCheckoutRequest}
 */
proto.acompanha.checkouts.v1.GetCheckoutRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUuid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.checkouts.v1.GetCheckoutRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.checkouts.v1.GetCheckoutRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.checkouts.v1.GetCheckoutRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.checkouts.v1.GetCheckoutRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUuid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string uuid = 1;
 * @return {string}
 */
proto.acompanha.checkouts.v1.GetCheckoutRequest.prototype.getUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.checkouts.v1.GetCheckoutRequest} returns this
 */
proto.acompanha.checkouts.v1.GetCheckoutRequest.prototype.setUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.checkouts.v1.GetCheckoutResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.checkouts.v1.GetCheckoutResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.checkouts.v1.GetCheckoutResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.checkouts.v1.GetCheckoutResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
data: (f = msg.getData()) && proto.acompanha.checkouts.v1.Checkout.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.checkouts.v1.GetCheckoutResponse}
 */
proto.acompanha.checkouts.v1.GetCheckoutResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.checkouts.v1.GetCheckoutResponse;
  return proto.acompanha.checkouts.v1.GetCheckoutResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.checkouts.v1.GetCheckoutResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.checkouts.v1.GetCheckoutResponse}
 */
proto.acompanha.checkouts.v1.GetCheckoutResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.acompanha.checkouts.v1.Checkout;
      reader.readMessage(value,proto.acompanha.checkouts.v1.Checkout.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.checkouts.v1.GetCheckoutResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.checkouts.v1.GetCheckoutResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.checkouts.v1.GetCheckoutResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.checkouts.v1.GetCheckoutResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.acompanha.checkouts.v1.Checkout.serializeBinaryToWriter
    );
  }
};


/**
 * optional Checkout data = 1;
 * @return {?proto.acompanha.checkouts.v1.Checkout}
 */
proto.acompanha.checkouts.v1.GetCheckoutResponse.prototype.getData = function() {
  return /** @type{?proto.acompanha.checkouts.v1.Checkout} */ (
    jspb.Message.getWrapperField(this, proto.acompanha.checkouts.v1.Checkout, 1));
};


/**
 * @param {?proto.acompanha.checkouts.v1.Checkout|undefined} value
 * @return {!proto.acompanha.checkouts.v1.GetCheckoutResponse} returns this
*/
proto.acompanha.checkouts.v1.GetCheckoutResponse.prototype.setData = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.checkouts.v1.GetCheckoutResponse} returns this
 */
proto.acompanha.checkouts.v1.GetCheckoutResponse.prototype.clearData = function() {
  return this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.checkouts.v1.GetCheckoutResponse.prototype.hasData = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.acompanha.checkouts.v1.CreateCheckoutRequest.repeatedFields_ = [3,7];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.checkouts.v1.CreateCheckoutRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.checkouts.v1.CreateCheckoutRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.checkouts.v1.CreateCheckoutRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.checkouts.v1.CreateCheckoutRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
customer: (f = msg.getCustomer()) && acompanha_common_v1_common_pb.CustomerRef.toObject(includeInstance, f),
shippingMethod: (f = msg.getShippingMethod()) && acompanha_common_v1_common_pb.ShippingMethodRef.toObject(includeInstance, f),
productsList: jspb.Message.toObjectList(msg.getProductsList(),
    acompanha_common_v1_common_pb.CheckoutProduct.toObject, includeInstance),
amount: jspb.Message.getFieldWithDefault(msg, 4, 0),
salesChannel: (f = msg.getSalesChannel()) && acompanha_common_v1_common_pb.SalesChannelRef.toObject(includeInstance, f),
finishOrder: jspb.Message.getBooleanFieldWithDefault(msg, 6, false),
paymentMethodsList: jspb.Message.toObjectList(msg.getPaymentMethodsList(),
    acompanha_common_v1_common_pb.PaymentMethod.toObject, includeInstance),
paymentDetails: (f = msg.getPaymentDetails()) && acompanha_common_v1_common_pb.PaymentDetails.toObject(includeInstance, f),
photo: msg.getPhoto_asB64(),
createdAt: (f = msg.getCreatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.checkouts.v1.CreateCheckoutRequest}
 */
proto.acompanha.checkouts.v1.CreateCheckoutRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.checkouts.v1.CreateCheckoutRequest;
  return proto.acompanha.checkouts.v1.CreateCheckoutRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.checkouts.v1.CreateCheckoutRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.checkouts.v1.CreateCheckoutRequest}
 */
proto.acompanha.checkouts.v1.CreateCheckoutRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new acompanha_common_v1_common_pb.CustomerRef;
      reader.readMessage(value,acompanha_common_v1_common_pb.CustomerRef.deserializeBinaryFromReader);
      msg.setCustomer(value);
      break;
    case 2:
      var value = new acompanha_common_v1_common_pb.ShippingMethodRef;
      reader.readMessage(value,acompanha_common_v1_common_pb.ShippingMethodRef.deserializeBinaryFromReader);
      msg.setShippingMethod(value);
      break;
    case 3:
      var value = new acompanha_common_v1_common_pb.CheckoutProduct;
      reader.readMessage(value,acompanha_common_v1_common_pb.CheckoutProduct.deserializeBinaryFromReader);
      msg.addProducts(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAmount(value);
      break;
    case 5:
      var value = new acompanha_common_v1_common_pb.SalesChannelRef;
      reader.readMessage(value,acompanha_common_v1_common_pb.SalesChannelRef.deserializeBinaryFromReader);
      msg.setSalesChannel(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setFinishOrder(value);
      break;
    case 7:
      var value = new acompanha_common_v1_common_pb.PaymentMethod;
      reader.readMessage(value,acompanha_common_v1_common_pb.PaymentMethod.deserializeBinaryFromReader);
      msg.addPaymentMethods(value);
      break;
    case 8:
      var value = new acompanha_common_v1_common_pb.PaymentDetails;
      reader.readMessage(value,acompanha_common_v1_common_pb.PaymentDetails.deserializeBinaryFromReader);
      msg.setPaymentDetails(value);
      break;
    case 9:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setPhoto(value);
      break;
    case 10:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedAt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.checkouts.v1.CreateCheckoutRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.checkouts.v1.CreateCheckoutRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.checkouts.v1.CreateCheckoutRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.checkouts.v1.CreateCheckoutRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCustomer();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      acompanha_common_v1_common_pb.CustomerRef.serializeBinaryToWriter
    );
  }
  f = message.getShippingMethod();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      acompanha_common_v1_common_pb.ShippingMethodRef.serializeBinaryToWriter
    );
  }
  f = message.getProductsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      acompanha_common_v1_common_pb.CheckoutProduct.serializeBinaryToWriter
    );
  }
  f = message.getAmount();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getSalesChannel();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      acompanha_common_v1_common_pb.SalesChannelRef.serializeBinaryToWriter
    );
  }
  f = message.getFinishOrder();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
  f = message.getPaymentMethodsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      7,
      f,
      acompanha_common_v1_common_pb.PaymentMethod.serializeBinaryToWriter
    );
  }
  f = message.getPaymentDetails();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      acompanha_common_v1_common_pb.PaymentDetails.serializeBinaryToWriter
    );
  }
  f = message.getPhoto_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      9,
      f
    );
  }
  f = message.getCreatedAt();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional acompanha.common.v1.CustomerRef customer = 1;
 * @return {?proto.acompanha.common.v1.CustomerRef}
 */
proto.acompanha.checkouts.v1.CreateCheckoutRequest.prototype.getCustomer = function() {
  return /** @type{?proto.acompanha.common.v1.CustomerRef} */ (
    jspb.Message.getWrapperField(this, acompanha_common_v1_common_pb.CustomerRef, 1));
};


/**
 * @param {?proto.acompanha.common.v1.CustomerRef|undefined} value
 * @return {!proto.acompanha.checkouts.v1.CreateCheckoutRequest} returns this
*/
proto.acompanha.checkouts.v1.CreateCheckoutRequest.prototype.setCustomer = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.checkouts.v1.CreateCheckoutRequest} returns this
 */
proto.acompanha.checkouts.v1.CreateCheckoutRequest.prototype.clearCustomer = function() {
  return this.setCustomer(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.checkouts.v1.CreateCheckoutRequest.prototype.hasCustomer = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional acompanha.common.v1.ShippingMethodRef shipping_method = 2;
 * @return {?proto.acompanha.common.v1.ShippingMethodRef}
 */
proto.acompanha.checkouts.v1.CreateCheckoutRequest.prototype.getShippingMethod = function() {
  return /** @type{?proto.acompanha.common.v1.ShippingMethodRef} */ (
    jspb.Message.getWrapperField(this, acompanha_common_v1_common_pb.ShippingMethodRef, 2));
};


/**
 * @param {?proto.acompanha.common.v1.ShippingMethodRef|undefined} value
 * @return {!proto.acompanha.checkouts.v1.CreateCheckoutRequest} returns this
*/
proto.acompanha.checkouts.v1.CreateCheckoutRequest.prototype.setShippingMethod = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.checkouts.v1.CreateCheckoutRequest} returns this
 */
proto.acompanha.checkouts.v1.CreateCheckoutRequest.prototype.clearShippingMethod = function() {
  return this.setShippingMethod(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.checkouts.v1.CreateCheckoutRequest.prototype.hasShippingMethod = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated acompanha.common.v1.CheckoutProduct products = 3;
 * @return {!Array<!proto.acompanha.common.v1.CheckoutProduct>}
 */
proto.acompanha.checkouts.v1.CreateCheckoutRequest.prototype.getProductsList = function() {
  return /** @type{!Array<!proto.acompanha.common.v1.CheckoutProduct>} */ (
    jspb.Message.getRepeatedWrapperField(this, acompanha_common_v1_common_pb.CheckoutProduct, 3));
};


/**
 * @param {!Array<!proto.acompanha.common.v1.CheckoutProduct>} value
 * @return {!proto.acompanha.checkouts.v1.CreateCheckoutRequest} returns this
*/
proto.acompanha.checkouts.v1.CreateCheckoutRequest.prototype.setProductsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.acompanha.common.v1.CheckoutProduct=} opt_value
 * @param {number=} opt_index
 * @return {!proto.acompanha.common.v1.CheckoutProduct}
 */
proto.acompanha.checkouts.v1.CreateCheckoutRequest.prototype.addProducts = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.acompanha.common.v1.CheckoutProduct, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.acompanha.checkouts.v1.CreateCheckoutRequest} returns this
 */
proto.acompanha.checkouts.v1.CreateCheckoutRequest.prototype.clearProductsList = function() {
  return this.setProductsList([]);
};


/**
 * optional int64 amount = 4;
 * @return {number}
 */
proto.acompanha.checkouts.v1.CreateCheckoutRequest.prototype.getAmount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.checkouts.v1.CreateCheckoutRequest} returns this
 */
proto.acompanha.checkouts.v1.CreateCheckoutRequest.prototype.setAmount = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional acompanha.common.v1.SalesChannelRef sales_channel = 5;
 * @return {?proto.acompanha.common.v1.SalesChannelRef}
 */
proto.acompanha.checkouts.v1.CreateCheckoutRequest.prototype.getSalesChannel = function() {
  return /** @type{?proto.acompanha.common.v1.SalesChannelRef} */ (
    jspb.Message.getWrapperField(this, acompanha_common_v1_common_pb.SalesChannelRef, 5));
};


/**
 * @param {?proto.acompanha.common.v1.SalesChannelRef|undefined} value
 * @return {!proto.acompanha.checkouts.v1.CreateCheckoutRequest} returns this
*/
proto.acompanha.checkouts.v1.CreateCheckoutRequest.prototype.setSalesChannel = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.checkouts.v1.CreateCheckoutRequest} returns this
 */
proto.acompanha.checkouts.v1.CreateCheckoutRequest.prototype.clearSalesChannel = function() {
  return this.setSalesChannel(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.checkouts.v1.CreateCheckoutRequest.prototype.hasSalesChannel = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional bool finish_order = 6;
 * @return {boolean}
 */
proto.acompanha.checkouts.v1.CreateCheckoutRequest.prototype.getFinishOrder = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.acompanha.checkouts.v1.CreateCheckoutRequest} returns this
 */
proto.acompanha.checkouts.v1.CreateCheckoutRequest.prototype.setFinishOrder = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};


/**
 * repeated acompanha.common.v1.PaymentMethod payment_methods = 7;
 * @return {!Array<!proto.acompanha.common.v1.PaymentMethod>}
 */
proto.acompanha.checkouts.v1.CreateCheckoutRequest.prototype.getPaymentMethodsList = function() {
  return /** @type{!Array<!proto.acompanha.common.v1.PaymentMethod>} */ (
    jspb.Message.getRepeatedWrapperField(this, acompanha_common_v1_common_pb.PaymentMethod, 7));
};


/**
 * @param {!Array<!proto.acompanha.common.v1.PaymentMethod>} value
 * @return {!proto.acompanha.checkouts.v1.CreateCheckoutRequest} returns this
*/
proto.acompanha.checkouts.v1.CreateCheckoutRequest.prototype.setPaymentMethodsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 7, value);
};


/**
 * @param {!proto.acompanha.common.v1.PaymentMethod=} opt_value
 * @param {number=} opt_index
 * @return {!proto.acompanha.common.v1.PaymentMethod}
 */
proto.acompanha.checkouts.v1.CreateCheckoutRequest.prototype.addPaymentMethods = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 7, opt_value, proto.acompanha.common.v1.PaymentMethod, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.acompanha.checkouts.v1.CreateCheckoutRequest} returns this
 */
proto.acompanha.checkouts.v1.CreateCheckoutRequest.prototype.clearPaymentMethodsList = function() {
  return this.setPaymentMethodsList([]);
};


/**
 * optional acompanha.common.v1.PaymentDetails payment_details = 8;
 * @return {?proto.acompanha.common.v1.PaymentDetails}
 */
proto.acompanha.checkouts.v1.CreateCheckoutRequest.prototype.getPaymentDetails = function() {
  return /** @type{?proto.acompanha.common.v1.PaymentDetails} */ (
    jspb.Message.getWrapperField(this, acompanha_common_v1_common_pb.PaymentDetails, 8));
};


/**
 * @param {?proto.acompanha.common.v1.PaymentDetails|undefined} value
 * @return {!proto.acompanha.checkouts.v1.CreateCheckoutRequest} returns this
*/
proto.acompanha.checkouts.v1.CreateCheckoutRequest.prototype.setPaymentDetails = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.checkouts.v1.CreateCheckoutRequest} returns this
 */
proto.acompanha.checkouts.v1.CreateCheckoutRequest.prototype.clearPaymentDetails = function() {
  return this.setPaymentDetails(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.checkouts.v1.CreateCheckoutRequest.prototype.hasPaymentDetails = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional bytes photo = 9;
 * @return {!(string|Uint8Array)}
 */
proto.acompanha.checkouts.v1.CreateCheckoutRequest.prototype.getPhoto = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * optional bytes photo = 9;
 * This is a type-conversion wrapper around `getPhoto()`
 * @return {string}
 */
proto.acompanha.checkouts.v1.CreateCheckoutRequest.prototype.getPhoto_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getPhoto()));
};


/**
 * optional bytes photo = 9;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getPhoto()`
 * @return {!Uint8Array}
 */
proto.acompanha.checkouts.v1.CreateCheckoutRequest.prototype.getPhoto_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getPhoto()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.acompanha.checkouts.v1.CreateCheckoutRequest} returns this
 */
proto.acompanha.checkouts.v1.CreateCheckoutRequest.prototype.setPhoto = function(value) {
  return jspb.Message.setProto3BytesField(this, 9, value);
};


/**
 * optional google.protobuf.Timestamp created_at = 10;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.acompanha.checkouts.v1.CreateCheckoutRequest.prototype.getCreatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 10));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.acompanha.checkouts.v1.CreateCheckoutRequest} returns this
*/
proto.acompanha.checkouts.v1.CreateCheckoutRequest.prototype.setCreatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.checkouts.v1.CreateCheckoutRequest} returns this
 */
proto.acompanha.checkouts.v1.CreateCheckoutRequest.prototype.clearCreatedAt = function() {
  return this.setCreatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.checkouts.v1.CreateCheckoutRequest.prototype.hasCreatedAt = function() {
  return jspb.Message.getField(this, 10) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.checkouts.v1.CreateCheckoutResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.checkouts.v1.CreateCheckoutResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.checkouts.v1.CreateCheckoutResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.checkouts.v1.CreateCheckoutResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
success: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
data: (f = msg.getData()) && proto.acompanha.checkouts.v1.Checkout.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.checkouts.v1.CreateCheckoutResponse}
 */
proto.acompanha.checkouts.v1.CreateCheckoutResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.checkouts.v1.CreateCheckoutResponse;
  return proto.acompanha.checkouts.v1.CreateCheckoutResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.checkouts.v1.CreateCheckoutResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.checkouts.v1.CreateCheckoutResponse}
 */
proto.acompanha.checkouts.v1.CreateCheckoutResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 2:
      var value = new proto.acompanha.checkouts.v1.Checkout;
      reader.readMessage(value,proto.acompanha.checkouts.v1.Checkout.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.checkouts.v1.CreateCheckoutResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.checkouts.v1.CreateCheckoutResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.checkouts.v1.CreateCheckoutResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.checkouts.v1.CreateCheckoutResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.acompanha.checkouts.v1.Checkout.serializeBinaryToWriter
    );
  }
};


/**
 * optional bool success = 1;
 * @return {boolean}
 */
proto.acompanha.checkouts.v1.CreateCheckoutResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.acompanha.checkouts.v1.CreateCheckoutResponse} returns this
 */
proto.acompanha.checkouts.v1.CreateCheckoutResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional Checkout data = 2;
 * @return {?proto.acompanha.checkouts.v1.Checkout}
 */
proto.acompanha.checkouts.v1.CreateCheckoutResponse.prototype.getData = function() {
  return /** @type{?proto.acompanha.checkouts.v1.Checkout} */ (
    jspb.Message.getWrapperField(this, proto.acompanha.checkouts.v1.Checkout, 2));
};


/**
 * @param {?proto.acompanha.checkouts.v1.Checkout|undefined} value
 * @return {!proto.acompanha.checkouts.v1.CreateCheckoutResponse} returns this
*/
proto.acompanha.checkouts.v1.CreateCheckoutResponse.prototype.setData = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.checkouts.v1.CreateCheckoutResponse} returns this
 */
proto.acompanha.checkouts.v1.CreateCheckoutResponse.prototype.clearData = function() {
  return this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.checkouts.v1.CreateCheckoutResponse.prototype.hasData = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.acompanha.checkouts.v1.UpdateCheckoutRequest.repeatedFields_ = [4,8];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.checkouts.v1.UpdateCheckoutRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.checkouts.v1.UpdateCheckoutRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.checkouts.v1.UpdateCheckoutRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.checkouts.v1.UpdateCheckoutRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
uuid: jspb.Message.getFieldWithDefault(msg, 1, ""),
customer: (f = msg.getCustomer()) && acompanha_common_v1_common_pb.CustomerRef.toObject(includeInstance, f),
shippingMethod: (f = msg.getShippingMethod()) && acompanha_common_v1_common_pb.ShippingMethodRef.toObject(includeInstance, f),
productsList: jspb.Message.toObjectList(msg.getProductsList(),
    acompanha_common_v1_common_pb.CheckoutProduct.toObject, includeInstance),
amount: jspb.Message.getFieldWithDefault(msg, 5, 0),
salesChannel: (f = msg.getSalesChannel()) && acompanha_common_v1_common_pb.SalesChannelRef.toObject(includeInstance, f),
finishOrder: jspb.Message.getBooleanFieldWithDefault(msg, 7, false),
paymentMethodsList: jspb.Message.toObjectList(msg.getPaymentMethodsList(),
    acompanha_common_v1_common_pb.PaymentMethod.toObject, includeInstance),
paymentDetails: (f = msg.getPaymentDetails()) && acompanha_common_v1_common_pb.PaymentDetails.toObject(includeInstance, f),
photo: msg.getPhoto_asB64()
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.checkouts.v1.UpdateCheckoutRequest}
 */
proto.acompanha.checkouts.v1.UpdateCheckoutRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.checkouts.v1.UpdateCheckoutRequest;
  return proto.acompanha.checkouts.v1.UpdateCheckoutRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.checkouts.v1.UpdateCheckoutRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.checkouts.v1.UpdateCheckoutRequest}
 */
proto.acompanha.checkouts.v1.UpdateCheckoutRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUuid(value);
      break;
    case 2:
      var value = new acompanha_common_v1_common_pb.CustomerRef;
      reader.readMessage(value,acompanha_common_v1_common_pb.CustomerRef.deserializeBinaryFromReader);
      msg.setCustomer(value);
      break;
    case 3:
      var value = new acompanha_common_v1_common_pb.ShippingMethodRef;
      reader.readMessage(value,acompanha_common_v1_common_pb.ShippingMethodRef.deserializeBinaryFromReader);
      msg.setShippingMethod(value);
      break;
    case 4:
      var value = new acompanha_common_v1_common_pb.CheckoutProduct;
      reader.readMessage(value,acompanha_common_v1_common_pb.CheckoutProduct.deserializeBinaryFromReader);
      msg.addProducts(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAmount(value);
      break;
    case 6:
      var value = new acompanha_common_v1_common_pb.SalesChannelRef;
      reader.readMessage(value,acompanha_common_v1_common_pb.SalesChannelRef.deserializeBinaryFromReader);
      msg.setSalesChannel(value);
      break;
    case 7:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setFinishOrder(value);
      break;
    case 8:
      var value = new acompanha_common_v1_common_pb.PaymentMethod;
      reader.readMessage(value,acompanha_common_v1_common_pb.PaymentMethod.deserializeBinaryFromReader);
      msg.addPaymentMethods(value);
      break;
    case 9:
      var value = new acompanha_common_v1_common_pb.PaymentDetails;
      reader.readMessage(value,acompanha_common_v1_common_pb.PaymentDetails.deserializeBinaryFromReader);
      msg.setPaymentDetails(value);
      break;
    case 10:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setPhoto(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.checkouts.v1.UpdateCheckoutRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.checkouts.v1.UpdateCheckoutRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.checkouts.v1.UpdateCheckoutRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.checkouts.v1.UpdateCheckoutRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUuid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCustomer();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      acompanha_common_v1_common_pb.CustomerRef.serializeBinaryToWriter
    );
  }
  f = message.getShippingMethod();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      acompanha_common_v1_common_pb.ShippingMethodRef.serializeBinaryToWriter
    );
  }
  f = message.getProductsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      acompanha_common_v1_common_pb.CheckoutProduct.serializeBinaryToWriter
    );
  }
  f = message.getAmount();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getSalesChannel();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      acompanha_common_v1_common_pb.SalesChannelRef.serializeBinaryToWriter
    );
  }
  f = message.getFinishOrder();
  if (f) {
    writer.writeBool(
      7,
      f
    );
  }
  f = message.getPaymentMethodsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      8,
      f,
      acompanha_common_v1_common_pb.PaymentMethod.serializeBinaryToWriter
    );
  }
  f = message.getPaymentDetails();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      acompanha_common_v1_common_pb.PaymentDetails.serializeBinaryToWriter
    );
  }
  f = message.getPhoto_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      10,
      f
    );
  }
};


/**
 * optional string uuid = 1;
 * @return {string}
 */
proto.acompanha.checkouts.v1.UpdateCheckoutRequest.prototype.getUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.checkouts.v1.UpdateCheckoutRequest} returns this
 */
proto.acompanha.checkouts.v1.UpdateCheckoutRequest.prototype.setUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional acompanha.common.v1.CustomerRef customer = 2;
 * @return {?proto.acompanha.common.v1.CustomerRef}
 */
proto.acompanha.checkouts.v1.UpdateCheckoutRequest.prototype.getCustomer = function() {
  return /** @type{?proto.acompanha.common.v1.CustomerRef} */ (
    jspb.Message.getWrapperField(this, acompanha_common_v1_common_pb.CustomerRef, 2));
};


/**
 * @param {?proto.acompanha.common.v1.CustomerRef|undefined} value
 * @return {!proto.acompanha.checkouts.v1.UpdateCheckoutRequest} returns this
*/
proto.acompanha.checkouts.v1.UpdateCheckoutRequest.prototype.setCustomer = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.checkouts.v1.UpdateCheckoutRequest} returns this
 */
proto.acompanha.checkouts.v1.UpdateCheckoutRequest.prototype.clearCustomer = function() {
  return this.setCustomer(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.checkouts.v1.UpdateCheckoutRequest.prototype.hasCustomer = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional acompanha.common.v1.ShippingMethodRef shipping_method = 3;
 * @return {?proto.acompanha.common.v1.ShippingMethodRef}
 */
proto.acompanha.checkouts.v1.UpdateCheckoutRequest.prototype.getShippingMethod = function() {
  return /** @type{?proto.acompanha.common.v1.ShippingMethodRef} */ (
    jspb.Message.getWrapperField(this, acompanha_common_v1_common_pb.ShippingMethodRef, 3));
};


/**
 * @param {?proto.acompanha.common.v1.ShippingMethodRef|undefined} value
 * @return {!proto.acompanha.checkouts.v1.UpdateCheckoutRequest} returns this
*/
proto.acompanha.checkouts.v1.UpdateCheckoutRequest.prototype.setShippingMethod = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.checkouts.v1.UpdateCheckoutRequest} returns this
 */
proto.acompanha.checkouts.v1.UpdateCheckoutRequest.prototype.clearShippingMethod = function() {
  return this.setShippingMethod(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.checkouts.v1.UpdateCheckoutRequest.prototype.hasShippingMethod = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * repeated acompanha.common.v1.CheckoutProduct products = 4;
 * @return {!Array<!proto.acompanha.common.v1.CheckoutProduct>}
 */
proto.acompanha.checkouts.v1.UpdateCheckoutRequest.prototype.getProductsList = function() {
  return /** @type{!Array<!proto.acompanha.common.v1.CheckoutProduct>} */ (
    jspb.Message.getRepeatedWrapperField(this, acompanha_common_v1_common_pb.CheckoutProduct, 4));
};


/**
 * @param {!Array<!proto.acompanha.common.v1.CheckoutProduct>} value
 * @return {!proto.acompanha.checkouts.v1.UpdateCheckoutRequest} returns this
*/
proto.acompanha.checkouts.v1.UpdateCheckoutRequest.prototype.setProductsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.acompanha.common.v1.CheckoutProduct=} opt_value
 * @param {number=} opt_index
 * @return {!proto.acompanha.common.v1.CheckoutProduct}
 */
proto.acompanha.checkouts.v1.UpdateCheckoutRequest.prototype.addProducts = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.acompanha.common.v1.CheckoutProduct, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.acompanha.checkouts.v1.UpdateCheckoutRequest} returns this
 */
proto.acompanha.checkouts.v1.UpdateCheckoutRequest.prototype.clearProductsList = function() {
  return this.setProductsList([]);
};


/**
 * optional int64 amount = 5;
 * @return {number}
 */
proto.acompanha.checkouts.v1.UpdateCheckoutRequest.prototype.getAmount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.checkouts.v1.UpdateCheckoutRequest} returns this
 */
proto.acompanha.checkouts.v1.UpdateCheckoutRequest.prototype.setAmount = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional acompanha.common.v1.SalesChannelRef sales_channel = 6;
 * @return {?proto.acompanha.common.v1.SalesChannelRef}
 */
proto.acompanha.checkouts.v1.UpdateCheckoutRequest.prototype.getSalesChannel = function() {
  return /** @type{?proto.acompanha.common.v1.SalesChannelRef} */ (
    jspb.Message.getWrapperField(this, acompanha_common_v1_common_pb.SalesChannelRef, 6));
};


/**
 * @param {?proto.acompanha.common.v1.SalesChannelRef|undefined} value
 * @return {!proto.acompanha.checkouts.v1.UpdateCheckoutRequest} returns this
*/
proto.acompanha.checkouts.v1.UpdateCheckoutRequest.prototype.setSalesChannel = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.checkouts.v1.UpdateCheckoutRequest} returns this
 */
proto.acompanha.checkouts.v1.UpdateCheckoutRequest.prototype.clearSalesChannel = function() {
  return this.setSalesChannel(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.checkouts.v1.UpdateCheckoutRequest.prototype.hasSalesChannel = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional bool finish_order = 7;
 * @return {boolean}
 */
proto.acompanha.checkouts.v1.UpdateCheckoutRequest.prototype.getFinishOrder = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 7, false));
};


/**
 * @param {boolean} value
 * @return {!proto.acompanha.checkouts.v1.UpdateCheckoutRequest} returns this
 */
proto.acompanha.checkouts.v1.UpdateCheckoutRequest.prototype.setFinishOrder = function(value) {
  return jspb.Message.setProto3BooleanField(this, 7, value);
};


/**
 * repeated acompanha.common.v1.PaymentMethod payment_methods = 8;
 * @return {!Array<!proto.acompanha.common.v1.PaymentMethod>}
 */
proto.acompanha.checkouts.v1.UpdateCheckoutRequest.prototype.getPaymentMethodsList = function() {
  return /** @type{!Array<!proto.acompanha.common.v1.PaymentMethod>} */ (
    jspb.Message.getRepeatedWrapperField(this, acompanha_common_v1_common_pb.PaymentMethod, 8));
};


/**
 * @param {!Array<!proto.acompanha.common.v1.PaymentMethod>} value
 * @return {!proto.acompanha.checkouts.v1.UpdateCheckoutRequest} returns this
*/
proto.acompanha.checkouts.v1.UpdateCheckoutRequest.prototype.setPaymentMethodsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 8, value);
};


/**
 * @param {!proto.acompanha.common.v1.PaymentMethod=} opt_value
 * @param {number=} opt_index
 * @return {!proto.acompanha.common.v1.PaymentMethod}
 */
proto.acompanha.checkouts.v1.UpdateCheckoutRequest.prototype.addPaymentMethods = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 8, opt_value, proto.acompanha.common.v1.PaymentMethod, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.acompanha.checkouts.v1.UpdateCheckoutRequest} returns this
 */
proto.acompanha.checkouts.v1.UpdateCheckoutRequest.prototype.clearPaymentMethodsList = function() {
  return this.setPaymentMethodsList([]);
};


/**
 * optional acompanha.common.v1.PaymentDetails payment_details = 9;
 * @return {?proto.acompanha.common.v1.PaymentDetails}
 */
proto.acompanha.checkouts.v1.UpdateCheckoutRequest.prototype.getPaymentDetails = function() {
  return /** @type{?proto.acompanha.common.v1.PaymentDetails} */ (
    jspb.Message.getWrapperField(this, acompanha_common_v1_common_pb.PaymentDetails, 9));
};


/**
 * @param {?proto.acompanha.common.v1.PaymentDetails|undefined} value
 * @return {!proto.acompanha.checkouts.v1.UpdateCheckoutRequest} returns this
*/
proto.acompanha.checkouts.v1.UpdateCheckoutRequest.prototype.setPaymentDetails = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.checkouts.v1.UpdateCheckoutRequest} returns this
 */
proto.acompanha.checkouts.v1.UpdateCheckoutRequest.prototype.clearPaymentDetails = function() {
  return this.setPaymentDetails(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.checkouts.v1.UpdateCheckoutRequest.prototype.hasPaymentDetails = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional bytes photo = 10;
 * @return {!(string|Uint8Array)}
 */
proto.acompanha.checkouts.v1.UpdateCheckoutRequest.prototype.getPhoto = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * optional bytes photo = 10;
 * This is a type-conversion wrapper around `getPhoto()`
 * @return {string}
 */
proto.acompanha.checkouts.v1.UpdateCheckoutRequest.prototype.getPhoto_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getPhoto()));
};


/**
 * optional bytes photo = 10;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getPhoto()`
 * @return {!Uint8Array}
 */
proto.acompanha.checkouts.v1.UpdateCheckoutRequest.prototype.getPhoto_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getPhoto()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.acompanha.checkouts.v1.UpdateCheckoutRequest} returns this
 */
proto.acompanha.checkouts.v1.UpdateCheckoutRequest.prototype.setPhoto = function(value) {
  return jspb.Message.setProto3BytesField(this, 10, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.checkouts.v1.UpdateCheckoutResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.checkouts.v1.UpdateCheckoutResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.checkouts.v1.UpdateCheckoutResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.checkouts.v1.UpdateCheckoutResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
success: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
data: (f = msg.getData()) && proto.acompanha.checkouts.v1.Checkout.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.checkouts.v1.UpdateCheckoutResponse}
 */
proto.acompanha.checkouts.v1.UpdateCheckoutResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.checkouts.v1.UpdateCheckoutResponse;
  return proto.acompanha.checkouts.v1.UpdateCheckoutResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.checkouts.v1.UpdateCheckoutResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.checkouts.v1.UpdateCheckoutResponse}
 */
proto.acompanha.checkouts.v1.UpdateCheckoutResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 2:
      var value = new proto.acompanha.checkouts.v1.Checkout;
      reader.readMessage(value,proto.acompanha.checkouts.v1.Checkout.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.checkouts.v1.UpdateCheckoutResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.checkouts.v1.UpdateCheckoutResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.checkouts.v1.UpdateCheckoutResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.checkouts.v1.UpdateCheckoutResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.acompanha.checkouts.v1.Checkout.serializeBinaryToWriter
    );
  }
};


/**
 * optional bool success = 1;
 * @return {boolean}
 */
proto.acompanha.checkouts.v1.UpdateCheckoutResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.acompanha.checkouts.v1.UpdateCheckoutResponse} returns this
 */
proto.acompanha.checkouts.v1.UpdateCheckoutResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional Checkout data = 2;
 * @return {?proto.acompanha.checkouts.v1.Checkout}
 */
proto.acompanha.checkouts.v1.UpdateCheckoutResponse.prototype.getData = function() {
  return /** @type{?proto.acompanha.checkouts.v1.Checkout} */ (
    jspb.Message.getWrapperField(this, proto.acompanha.checkouts.v1.Checkout, 2));
};


/**
 * @param {?proto.acompanha.checkouts.v1.Checkout|undefined} value
 * @return {!proto.acompanha.checkouts.v1.UpdateCheckoutResponse} returns this
*/
proto.acompanha.checkouts.v1.UpdateCheckoutResponse.prototype.setData = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.checkouts.v1.UpdateCheckoutResponse} returns this
 */
proto.acompanha.checkouts.v1.UpdateCheckoutResponse.prototype.clearData = function() {
  return this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.checkouts.v1.UpdateCheckoutResponse.prototype.hasData = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.checkouts.v1.DeleteCheckoutRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.checkouts.v1.DeleteCheckoutRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.checkouts.v1.DeleteCheckoutRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.checkouts.v1.DeleteCheckoutRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
uuid: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.checkouts.v1.DeleteCheckoutRequest}
 */
proto.acompanha.checkouts.v1.DeleteCheckoutRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.checkouts.v1.DeleteCheckoutRequest;
  return proto.acompanha.checkouts.v1.DeleteCheckoutRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.checkouts.v1.DeleteCheckoutRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.checkouts.v1.DeleteCheckoutRequest}
 */
proto.acompanha.checkouts.v1.DeleteCheckoutRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUuid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.checkouts.v1.DeleteCheckoutRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.checkouts.v1.DeleteCheckoutRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.checkouts.v1.DeleteCheckoutRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.checkouts.v1.DeleteCheckoutRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUuid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string uuid = 1;
 * @return {string}
 */
proto.acompanha.checkouts.v1.DeleteCheckoutRequest.prototype.getUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.checkouts.v1.DeleteCheckoutRequest} returns this
 */
proto.acompanha.checkouts.v1.DeleteCheckoutRequest.prototype.setUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.checkouts.v1.QuickCheckoutRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.checkouts.v1.QuickCheckoutRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.checkouts.v1.QuickCheckoutRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.checkouts.v1.QuickCheckoutRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
amount: jspb.Message.getFieldWithDefault(msg, 1, 0),
paymentType: jspb.Message.getFieldWithDefault(msg, 2, ""),
photo: msg.getPhoto_asB64()
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.checkouts.v1.QuickCheckoutRequest}
 */
proto.acompanha.checkouts.v1.QuickCheckoutRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.checkouts.v1.QuickCheckoutRequest;
  return proto.acompanha.checkouts.v1.QuickCheckoutRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.checkouts.v1.QuickCheckoutRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.checkouts.v1.QuickCheckoutRequest}
 */
proto.acompanha.checkouts.v1.QuickCheckoutRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAmount(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPaymentType(value);
      break;
    case 3:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setPhoto(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.checkouts.v1.QuickCheckoutRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.checkouts.v1.QuickCheckoutRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.checkouts.v1.QuickCheckoutRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.checkouts.v1.QuickCheckoutRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAmount();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getPaymentType();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPhoto_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      3,
      f
    );
  }
};


/**
 * optional int64 amount = 1;
 * @return {number}
 */
proto.acompanha.checkouts.v1.QuickCheckoutRequest.prototype.getAmount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.checkouts.v1.QuickCheckoutRequest} returns this
 */
proto.acompanha.checkouts.v1.QuickCheckoutRequest.prototype.setAmount = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string payment_type = 2;
 * @return {string}
 */
proto.acompanha.checkouts.v1.QuickCheckoutRequest.prototype.getPaymentType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.checkouts.v1.QuickCheckoutRequest} returns this
 */
proto.acompanha.checkouts.v1.QuickCheckoutRequest.prototype.setPaymentType = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional bytes photo = 3;
 * @return {!(string|Uint8Array)}
 */
proto.acompanha.checkouts.v1.QuickCheckoutRequest.prototype.getPhoto = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * optional bytes photo = 3;
 * This is a type-conversion wrapper around `getPhoto()`
 * @return {string}
 */
proto.acompanha.checkouts.v1.QuickCheckoutRequest.prototype.getPhoto_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getPhoto()));
};


/**
 * optional bytes photo = 3;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getPhoto()`
 * @return {!Uint8Array}
 */
proto.acompanha.checkouts.v1.QuickCheckoutRequest.prototype.getPhoto_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getPhoto()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.acompanha.checkouts.v1.QuickCheckoutRequest} returns this
 */
proto.acompanha.checkouts.v1.QuickCheckoutRequest.prototype.setPhoto = function(value) {
  return jspb.Message.setProto3BytesField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.checkouts.v1.QuickCheckoutResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.checkouts.v1.QuickCheckoutResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.checkouts.v1.QuickCheckoutResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.checkouts.v1.QuickCheckoutResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
success: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
data: (f = msg.getData()) && proto.acompanha.checkouts.v1.Checkout.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.checkouts.v1.QuickCheckoutResponse}
 */
proto.acompanha.checkouts.v1.QuickCheckoutResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.checkouts.v1.QuickCheckoutResponse;
  return proto.acompanha.checkouts.v1.QuickCheckoutResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.checkouts.v1.QuickCheckoutResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.checkouts.v1.QuickCheckoutResponse}
 */
proto.acompanha.checkouts.v1.QuickCheckoutResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 2:
      var value = new proto.acompanha.checkouts.v1.Checkout;
      reader.readMessage(value,proto.acompanha.checkouts.v1.Checkout.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.checkouts.v1.QuickCheckoutResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.checkouts.v1.QuickCheckoutResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.checkouts.v1.QuickCheckoutResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.checkouts.v1.QuickCheckoutResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.acompanha.checkouts.v1.Checkout.serializeBinaryToWriter
    );
  }
};


/**
 * optional bool success = 1;
 * @return {boolean}
 */
proto.acompanha.checkouts.v1.QuickCheckoutResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.acompanha.checkouts.v1.QuickCheckoutResponse} returns this
 */
proto.acompanha.checkouts.v1.QuickCheckoutResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional Checkout data = 2;
 * @return {?proto.acompanha.checkouts.v1.Checkout}
 */
proto.acompanha.checkouts.v1.QuickCheckoutResponse.prototype.getData = function() {
  return /** @type{?proto.acompanha.checkouts.v1.Checkout} */ (
    jspb.Message.getWrapperField(this, proto.acompanha.checkouts.v1.Checkout, 2));
};


/**
 * @param {?proto.acompanha.checkouts.v1.Checkout|undefined} value
 * @return {!proto.acompanha.checkouts.v1.QuickCheckoutResponse} returns this
*/
proto.acompanha.checkouts.v1.QuickCheckoutResponse.prototype.setData = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.checkouts.v1.QuickCheckoutResponse} returns this
 */
proto.acompanha.checkouts.v1.QuickCheckoutResponse.prototype.clearData = function() {
  return this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.checkouts.v1.QuickCheckoutResponse.prototype.hasData = function() {
  return jspb.Message.getField(this, 2) != null;
};


goog.object.extend(exports, proto.acompanha.checkouts.v1);
